import React from 'react';

import styles from './style.scss';

import AccordionItem from './AccordionItem';


const Accordion = ({ data }) => {
  return (
    <div className={styles.wrapper}>
      <ul className={styles.accordionList}>
        {data.map((data, index) => {
          return (
            <li className={styles.accordionListItem} key={index}>
              <AccordionItem {...data} />
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Accordion;
